import { alerjiler, teslimKisiti } from "../domain/students.js";
import { B } from "../domain/context.js";
import { age, esc, money } from "../lib/fmt.js";
import { avatar } from "../lib/avatar.js";
import { card, classChip, emptyNote } from "../components/ui.js";
import { hesapOzeti } from "../domain/invoices.js";
import { state } from "../state.js";

// ---------- ÖĞRENCİLER ----------
export function viewOgrenciler() {
  const t = B();
  const q = state.studentQuery.toLocaleLowerCase("tr-TR");
  const list = t.students.filter(s =>
    (state.studentClass === "all" || s.classId === state.studentClass) &&
    (!q || s.name.toLocaleLowerCase("tr-TR").includes(q) || s.parent.toLocaleLowerCase("tr-TR").includes(q))
  );

  return `
  <div class="flex flex-wrap gap-2 items-center mb-4">
    <input id="stuSearch" type="search" placeholder="Öğrenci veya veli ara…" value="${esc(state.studentQuery)}"
      class="rounded-xl border border-line bg-card px-4 py-2 text-sm w-full sm:w-64 focus:border-teal" />
    <div class="flex gap-1.5 flex-wrap">
      <button data-clsfilter="all" class="text-xs font-semibold rounded-full px-3 py-1.5 border ${state.studentClass === "all" ? "bg-ink text-white border-ink" : "bg-card border-line text-inksoft hover:border-ink/40"}">Tümü</button>
      ${t.classes.map(c => `
        <button data-clsfilter="${c.id}" class="text-xs font-semibold rounded-full px-3 py-1.5 border transition"
          style="${state.studentClass === c.id ? `background:${c.color};border-color:${c.color};color:#fff` : `background:#fff;border-color:#E8E6F0;color:${c.color}`}">
          ${esc(c.name)}</button>`).join("")}
    </div>
    <span class="text-xs text-inksoft ml-auto">${list.length} öğrenci</span>
  </div>

  <div class="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
    ${list.map(s => { const hesap = hesapOzeti(s); return card(`
      <button data-student="${s.id}" class="w-full p-4 text-left">
        <div class="flex items-center gap-3">
          ${avatar(s, "w-11 h-11 text-sm")}
          <div class="min-w-0 flex-1">
            <div class="font-semibold truncate">${esc(s.name)}</div>
            <div class="text-[11px] text-inksoft">${age(s.birthDate)}</div>
          </div>
          ${classChip(s.classId)}
        </div>
        <div class="flex flex-wrap gap-1.5 mt-3">
          ${alerjiler(s).map(a => `<span class="text-[10px] font-bold rounded-full px-2 py-0.5 ${a.severity === "anafilaksi" || a.severity === "agir" ? "bg-coral text-white" : "bg-coral-soft text-coral"}" title="${esc(a.response)}">⚠ ${esc(a.name)}${a.severity === "anafilaksi" ? " — anafilaksi" : ""}</span>`).join("")}
          ${teslimKisiti(s) ? `<span class="text-[10px] font-bold rounded-full bg-ink text-white px-2 py-0.5" title="${esc(teslimKisiti(s))}">🔒 Teslim kısıtı</span>` : ""}
          ${s.schedule === "yarim" ? `<span class="text-[10px] font-bold rounded-full bg-sun-soft text-[#B07E14] px-2 py-0.5">🕐 Yarım gün</span>` : ""}
          ${s.service ? `<span class="text-[10px] font-bold rounded-full bg-sky-soft text-sky px-2 py-0.5">🚌 Servis</span>` : ""}
          ${s.discount ? `<span class="text-[10px] font-bold rounded-full bg-teal-soft text-teal px-2 py-0.5">%${s.discount.pct} ${esc(s.discount.label)}</span>` : ""}
          ${/uyum/i.test(s.note) ? `<span class="text-[10px] font-bold rounded-full bg-grape-soft text-grape px-2 py-0.5">🌱 Uyum haftası</span>` : ""}
        </div>
        <div class="flex items-center justify-between gap-2 mt-2 pt-2 border-t border-line/70">
          <span class="text-[11px] text-inksoft truncate">${hesap.faturalar.length} fatura · ${money(hesap.tahsil)} tahsil</span>
          ${hesap.kalan > 0
            ? `<span class="text-[11px] font-bold text-coral shrink-0">Bakiye ${money(hesap.kalan)}</span>`
            : `<span class="text-[11px] font-bold text-teal shrink-0">Bakiye yok</span>`}
        </div>
      </button>`, "min-w-0 hover:shadow-pop transition-shadow"); }).join("") || card(emptyNote("Arama ile eşleşen öğrenci yok."), "sm:col-span-2 lg:col-span-3")}
  </div>`;
}

